import APIRequest from "./APIRequest";

// Update user profile (name only)
export const updateProfile = async (data) => {
  try {
    const response = await APIRequest.put("/profile/update-profile", data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Change password
export const changePassword = async (data) => {
  try {
    const response = await APIRequest.put("/profile/change-password", data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Send OTP for email verification
export const sendOTP = async (email) => {
  try {
    const response = await APIRequest.post("/auth/resend-otp", { email });
    return response;
  } catch (error) {
    throw error;
  }
};

// Verify OTP
export const verifyOTP = async (email, otp) => {
  try {
    const response = await APIRequest.post("/auth/verify-otp", { email, otp });
    return response;
  } catch (error) {
    throw error;
  }
};
